import React from "react";

export const AuthContext = React.createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = React.useState(null);
    // const [token, setToken] = React.useState(null);
    // const [refreshToken, setRefreshToken] = React.useState(null);

    // const login = (email, token, refreshToken) => {
    //     // login logic here
    //     setUser({ email });
    //     setToken({ token });
    //     setRefreshToken({ refreshToken });
    // };

    // const logout = () => {
    //     // logout logic here
    //     setUser(null);
    //     setToken(null)
    //     setRefreshToken(null);
    // };

    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
        {children}
        </AuthContext.Provider>
    );
};